module.exports = __webpack_public_path__ + "assets/img/favicon/apple-icon-120x120.9b58f8e2422d85e2edff356c6943a6fd.png";